import React from 'react';
import Projects from './Projects';

export default function ProjectGrid({ projects = [] }) {
  return (
    <div className="flex justify-center w-full">
      <section className='grid grid-cols-1 md:grid-cols-2 gap-x-20 gap-y-20'>
        {/* 1. Add 'index' to your map parameters */}
        {projects.map((project, index) => (
          <div key={project.id} className="flex justify-center">
            <Projects 
              projectDetails={{
                id: project.id, 
                projectName: project.title,
                category: project.category,
                year: project.year,
                imageUrl: project.imageUrl,
                bgColor: project.bgColor
              }} 
              /* 2. Pass a boolean flag to the child component. True for the first item, false for the rest. */
              isPriority={index === 0} 
            />
          </div>
        ))}
      </section>
    </div>
  );
}